export const AUSTRALIA_PHONE_EXTENSION_WITHOUT_PLUS = '61';

const AUSTRALIA_PHONE_EXTENSION = `+${AUSTRALIA_PHONE_EXTENSION_WITHOUT_PLUS}`;

export default AUSTRALIA_PHONE_EXTENSION;
